import { NavLink, useLocation } from "react-router-dom";

export default function Navbar() {
    const location = useLocation();
    const isHomepage = location.pathname === "/";

    // const navigate = useNavigate();

    // const handleContactClick = () => {
    //     navigate("/support");
    // };

    return (
        <>
            <nav
                className="navbar Navbar-Transparent-Background"
                role="navigation"
                aria-label="main navigation"
            >
                <NavLink className="Navbar-Brand-Container" to="/">
                    <img
                        src={`${process.env.PUBLIC_URL}/Quickmoji-Logos/Quickmoji-Logo_White.svg`}
                        className="Navbar-Logo-Image"
                        alt="Quickmoji Logo"
                    />
                    {!isHomepage && (
                        <h1 className="Navbar-Brand-Text">Quickmoji</h1>
                    )}
                </NavLink>

                {/* <div className="navbar-end">
                    <div className="navbar-item">
                        <button
                            className="button is-rounded is-white"
                            onClick={handleContactClick}
                        >
                            <p className="Navbar-Button-Text">Contact Us</p>
                        </button>
                    </div>
                </div> */}
            </nav>
        </>
    );
}
